import { NgModule } from '@angular/core';
import { BREAKPOINT } from '@angular/flex-layout';

// Registering these breakpoints like this as a provider will set the breakpoints that FlexLayout (and maybe other Angular stuff) will use.
// But it doesn't set the breakpoints that the bootstrap SCSS utilities use. So I created a variable called $app-breakpoints in the _variables.scss
// file that you should use when invoking the bootstrap SCSS utilities.
//
// Here is an example of the bootstrap SCSS utility usage using the $app-breakpoints:
//  @include bpUtil.media-breakpoint-up(lg, $app-breakpoints) {
//     ....
//  }
//
// If you update these breakpoints, then you should also update the $app-breakpoints variable in _variables.scss
const BOOTSTRAP_BREAKPOINTS = [
  { alias: 'xs', mediaQuery: 'screen and (max-width: 767px)'},
  { alias: 'sm', mediaQuery: 'screen and (min-width: 768px) and (max-width: 991px)'},
  { alias: 'md', mediaQuery: 'screen and (min-width: 992px) and (max-width: 1199px)'},
  { alias: 'lg', mediaQuery: 'screen and (min-width: 1200px) and (max-width: 1919px)'},
  { alias: 'xl', mediaQuery: 'screen and (min-width: 1920px) and (max-width: 5000px)'},

  { alias: 'lt-sm', mediaQuery: 'screen and (max-width: 767px)'},
  { alias: 'lt-md', mediaQuery: 'screen and (max-width: 991px)'},
  { alias: 'lt-lg', mediaQuery: 'screen and (max-width: 1199px)'},
  { alias: 'lt-xl', mediaQuery: 'screen and (max-width: 1919px)'},

  { alias: 'gt-xs', mediaQuery: 'screen and (min-width: 768px)'},
  { alias: 'gt-sm', mediaQuery: 'screen and (min-width: 992px)'},
  { alias: 'gt-md', mediaQuery: 'screen and (min-width: 1200px)'},
  { alias: 'gt-lg', mediaQuery: 'screen and (min-width: 1920px)'},
];

@NgModule({
  providers: [
    {
      provide : BREAKPOINT,
      useValue : BOOTSTRAP_BREAKPOINTS,
      multi: true
    }
  ]
})
export class AppBreakpointsModule { }
